<div class="tables-layout__canvas-view-container" id="canvaContainer">
  <div class="tables-layout__canvas-view" #canvasLoader >
    <!-- <ng-scrollbar [trackX]="true">   -->
    <canvas id="tablesLayout" #tablesLayout></canvas>
  <!-- </ng-scrollbar> -->

</div>

@if (locationDetail) {
  <div class="location-detail" [ngStyle]="locationDetail.position">
    <div class="location-detail__header-label" [class]="locationDetail.availability">
      {{locationDetail.availability | translate}}
    </div>
    <div class="location-detail__location-name">
      {{locationDetail.Name}}
    </div>
    @if (locationDetail.Price) {
      <div class="location-detail__location-name">
        {{  'Price' | translate }}: {{ guestService.selectedNonDining.OperationCurrency }} {{locationDetail.Price | currencyDecimalFormatter}}
      </div>
    }
    @if (guestService.validateLocationSize) {
      <div class="location-detail__party">
        {{locationDetail.MinPartySize}} {{'Min' | translate}} &nbsp; | &nbsp; {{locationDetail.MaxPartySize}} {{'Max' |
        translate}}
      </div>
    }
  </div>
}
</div>